import type { IPBTCase, IUpdatePbtCaseRequest } from '../../../Interfaces/IPBTCase';
import { IRequestCasesAction, IReceiveCasesAction, PBTCasesActionType, IErrorCasesAction, IResetCasesAction, IUpdateCaseRequestAction, IUpdateCaseSuccessAction, IUpdateCaseErrorAction } from './action-types';

// PBT cases request
export function requestCases(): IRequestCasesAction {
  return {
    type: PBTCasesActionType.REQUEST_CASES,
  };
}

export function receiveCases(data: IPBTCase[]): IReceiveCasesAction {
  return {
    type: PBTCasesActionType.RECEIVE_CASES,
    data: data,
  };
}

export function sendCasesError(errorMessage: string): IErrorCasesAction {
  return {
    type: PBTCasesActionType.ERROR_CASES,
    errorMessage,
  };
}

export function resetCases(): IResetCasesAction {
  return {
    type: PBTCasesActionType.RESET_CASES,
  };
}

export function updateCaseRequest(caseId: number, request: IUpdatePbtCaseRequest): IUpdateCaseRequestAction {
  return {
    type: PBTCasesActionType.UPDATE_CASE_REQUEST,
    caseId,
    request,
  };
}

export function updateCaseSuccess(updatedCase: IPBTCase): IUpdateCaseSuccessAction {
  return {
    type: PBTCasesActionType.UPDATE_CASE_SUCCESS,
    updatedCase,
  };
}

export function updateCaseError(errorMessage: string): IUpdateCaseErrorAction {
  return {
    type: PBTCasesActionType.UPDATE_CASE_ERROR,
    errorMessage,
  };
}
